// extracted by mini-css-extract-plugin
export var avatarContainer = "_4p-1";
export var largeAvatarContainer = "_4p-2";
export var smallAvatarContainer = "_4p-0";